import { Component, OnInit } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ButtonServiceService } from 'src/app/services/button-service.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { PopupComponent } from 'src/app/core/check/popup/popup.component';
import { CellsComponent } from 'src/app/core/grid-renderer/cells/cells.component';
import { SearchImgCellRendererComponent } from 'src/app/core/grid-renderer/search-img-cell-renderer/search-img-cell-renderer.component';
import { ViewEventDeletionsComponent } from '../view-event-deletions/view-event-deletions.component';
import { LegendsComponent } from '../legends/legends.component';
import { ColumnOptionsComponent } from '../column-options/column-options.component';
import { Constants } from 'src/app/constants';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import { DefaultConstant } from 'src/app/core/constant/defaultPref.constant';
import moment from 'moment';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-history-contents',
    templateUrl: './history-contents.component.html',
    styleUrls: ['./history-contents.component.scss'],
    standalone: false // NOSONAR
})
export class HistoryContentsComponent implements OnInit {

  faChevronRight = faChevronRight;
  preferenceData: any;
  successMessage: any;
  errorMessage: any;
  tempColDefn: any = [];
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: any = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  toyotaGUID: string;
  isAccessible=true;
  defaultPreferenceArr:any=[];
  preference:any;
  prefSeqId = 0;
  displayRowDataCopy: any[];
  columnArr = [{colId:'ab'},{colId:'al'},{colId:'bc'},{colId:'c'},{colId:'e'},{colId:'g'},{colId:'i'},
              {colId:'k'},{colId:'ms'},{colId:'mt'},{colId:'tx'},{colId:'u'},{colId:'wv'}]
  filtered: any[];
  domicileList: {};
  activeColumnFilters: Record<string, any[]> = {};
  gridContext: any;

  constructor(
      private readonly dialog : MatDialog,
    private readonly buttonService: ButtonServiceService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private  readonly constants: Constants,
     private readonly aetStateService : AetStateService, 
    private readonly router: Router) {
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true,
      suppressHeaderFilterButton: true,
      menuTabs: []
    }
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
    this.gridContext = { historyComponent: this };
  }


  shouldhide(fields) {
    const row = this.preferenceData?.find((item: any) => item?.name == fields);  // NOSONAR
    if (row?.name == fields && row.hidden == true) {  // NOSONAR
      return true;
    } else {
      return false;
    }
  }

  domicileDesc(field:any) {
    let retrunVal = '';
    for(const key in this.domicileList) {
      if(this.domicileList[key]['itemCode'] ==  field) {  // NOSONAR
        retrunVal = `${this.domicileList[key]['itemCode']} - ${this.domicileList[key]['itemDesc']}`;
      }   
    }
    if(retrunVal)
      {return retrunVal;}
    else
      {return '';}

  }

  

  ngOnInit(): void {
    this.filtered = [];
    this.activeColumnFilters = {};
    // this.checkRoles();
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    this.defaultPreferenceArr=DefaultConstant.defaultPreferenceArr;
    this.domicileList = {};
    this.loadPreferenceData();
    this.loadDomicile();
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setFilterModel(model);
    
  }

  // ngAfterViewInit() {
  //   let f = localStorage.getItem('footerheight');
  //   let h = localStorage.getItem('headerHeight');
  //   let t = localStorage.getItem('toolbarheight');
  //   console.info(f, h, t);
  //   let windowh = window.innerHeight;
  //   let headerfilter = document.getElementById('headerfilter')?.offsetHeight;
  //   let footerfilter = document.getElementById('footerfilter')?.offsetHeight;
  //   let paginationfooter = document.getElementById('footerfilter')?.offsetHeight;
  //   console.info(headerfilter, "headerfilter")
  //   const grid = document.getElementById('LIOS-grid');
  //   if (grid !=   null && headerfilter !=   null && footerfilter !=   null) {
  //     let gridHeight = (headerfilter + footerfilter +Number(f) + Number(h) + Number(t)) - 25;
  //     grid.style.height = 'calc(100vh - ' + (gridHeight) + 'px)';
  //     grid.style.maxHeight = 'calc(100vh - ' + (gridHeight) + 'px)';
  //   }
  // }
  
  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON.parse(roles);
  //   // this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  //   if (
  //     (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
  //     userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
  //     userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
  //     userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //     userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
  //     userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
  //     userRoles.includes(this.constants.LIOS_UAC_General_User))
  //   ) {
  //     if (
  //       (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
  //       userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
  //       userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_AET_LP))
  //     ) {
  //       this.isAccessible = true;
  //     }
  //   } else {
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }

  loadDomicile() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.buttonService.getDomicile()?.subscribe((res) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.domicileList = res;
    },(err) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      console.info(err);
      this.errorMessage = this.constants.APIErrorMessage;
    })
  }

  loadPreferenceData() {
    this.successMessage = null;
    this.errorMessage = null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      displayName: fgaDetails?.user?.displayName,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.buttonService.getload(userInfo)?.subscribe((response) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.preference = response;
      const preferenceFound = this.preference.filter(element => element.hidden == false);  // NOSONAR
      if(preferenceFound.length) {
        this.preferenceData = this.preference;
        this.prefSeqId = this.preference[0].prefSeqId;
      } else {
        this.preferenceData = this.defaultPreferenceArr;
        this.prefSeqId = 0;
      }

      this.getColDefs();
    }, (err) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      console.info(err);
      this.errorMessage = this.constants.APIErrorMessage;
    });
  }

  getColDefs() {// NOSONAR
    this.columnDefs = [
      {
        floatingFilterComponent: RefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true }, minWidth: 40, maxWidth: 40
      },
      {
        headerName: "CLOSED", field: "last_updated", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, 
        //maxWidth: 130, 
        hide: this.shouldhide('last_updated'),
        comparator: this.dateComparator,      menuTabs: []

        
      },
      {
        headerName: "ID", field: "event_id", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 50, 
        //maxWidth: 80, 
        hide: this.shouldhide('event_id'),      menuTabs: []

      },
      {
        headerName: "EVENT TYPE", field: "event_type", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 85, 
        //maxWidth: 100, 
        hide: this.shouldhide('event_type'),      menuTabs: []

      },
      {
        headerName: "PROBLEM TYPE", field: "problem_type", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 110, //maxWidth: 150, 
        hide: this.shouldhide('problem_type')
      },
      {
        headerName: "ROUTE", field: "puroute", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 80, //maxWidth: 100, 
        hide: this.shouldhide('puroute')
      },
      {
        headerName: "U/L", field: "arrival", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, //maxWidth: 130, 
        hide: this.shouldhide('arrival'),
        comparator: this.dateComparator
      },
      {
        headerName: "ROUTE GROUP", field: "route", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 100, //maxWidth: 120, 
        hide: this.shouldhide('route')
      },
      {
        headerName: "RUN", field: "run", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 55, //maxWidth: 80, 
        hide: this.shouldhide('run')
      },
      {
        headerName: "REGION", field: "region", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 75, //maxWidth: 90, 
        hide: this.shouldhide('region')
      },
      {
        headerName: "STATUS ID", field: "status_id", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 70, //maxWidth: 110, 
        hide: this.shouldhide('status_id')
      },
      {
        headerName: "STATUS", field: "status", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90,// maxWidth: 100,
         hide: this.shouldhide('status')
      },
      {
        headerName: "PROBLEM TYPE ID", field: "problem_type_id", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 110, //maxWidth: 130, 
        hide: this.shouldhide('problem_type_id')
      },
      {
        headerName: "LP ID", field: "transportation_provider_id", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 70, //maxWidth: 80,
         hide: this.shouldhide('transportation_provider_id')
      },
      {
        headerName: "LP", field: "transportation_provider", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, //maxWidth: 100, 
        hide: this.shouldhide('transportation_provider')
      },
      {
        headerName: "TRAILER", field: "eventTrailer", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 100, //maxWidth: 120, 
        hide: this.shouldhide('eventTrailer')
      },
      {
        headerName: "ETA", field: "eta", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, //maxWidth: 130,
         hide: this.shouldhide('eta'),
        comparator: this.dateComparator
      },
      {
        headerName: "LAST UPDATED BY", field: "last_updated_by", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, //maxWidth: 140, 
        hide: this.shouldhide('last_updated_by')
      },
      {
        headerTooltip: 'AB - TABC',
        // this.domicileDesc('AB'),
        headerName: "AB",
        field: "ab",
        suppressMenu: true, 
  floatingFilterComponent: PopupComponent,
        floatingFilterComponentParams: { suppressFilterButton: true, 
        filterChangedCallback: (value: any, colId: any) => {
          this.filterColumns(value, colId);
  }, }, minWidth: 48, maxWidth: 48,
        cellStyle: { "overflow": 'visible' }, cellRenderer: CellsComponent, hide: this.shouldhide('ab')
      },
      {
        headerTooltip:'AL - TMMAL',
        // this.domicileDesc('AL'),
        headerName: "AL", field: "al", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, hide: this.shouldhide('al'), cellRenderer: CellsComponent
      },
      {
        headerTooltip: 'BC - TMMBC',
        // this.domicileDesc('BC'),
        headerName: "BC", field: "bc", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('bc')
      },
      {
        headerTooltip: 'C - TMMC',
        // this.domicileDesc('C'),
        headerName: "C", field: "c", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('c')
      },
      {
        headerTooltip: 'EX - EXPORT',
        // this.domicileDesc('EX'),
        headerName: "EX", field: "ex", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          ;
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('ex')
      },
      {
        headerTooltip: 'GT - TMMGT',
        // this.domicileDesc('GT'),
        headerName: "GT", field: "gt", floatingFilterComponentParams: { suppressFilterButton: true ,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        }}, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('gt')
      },
      {
        headerTooltip: 'I - TMMI',
        // this.domicileDesc('I'),
        headerName: "I", field: "i", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('i')
      },
      {
        headerTooltip: 'K - TMMK',
        // this.domicileDesc('K'),
        headerName: "K", field: "k", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('k')
      },
      {
        headerTooltip: 'MS - TMMMS',
        // this.domicileDesc('MS'),
        headerName: "MS", field: "ms", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('ms')
      },
      {
        headerTooltip: 'MT - MTM',
        // this.domicileDesc('MT'),
        headerName: "MT", field: "mt", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('mt')
      },
      {
        headerTooltip: 'TX - TMMTX',
        // this.domicileDesc('TX'),
        headerName: "TX", field: "tx", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('tx')
      },
      // {
      //   headerTooltip: this.domicileDesc('U'),
      //   headerName: "U", field: "u", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
      //     this.filterColumns(value, colId);
      //   } }, floatingFilter: true,
      //   minWidth: 40, maxWidth: 40, floatingFilterComponentFramework: PopupComponent, cellRendererFramework: CellsComponent, hide: this.shouldhide('u')
      // },
      {
        headerTooltip: 'WV - TMMWV',
        // this.domicileDesc('WV'),
        headerName: "WV", field: "wv", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('wv')
      },
      {
        headerTooltip: 'KP - TMKPW',
        // this.domicileDesc('KP'),
        headerName: "KP", field: "kp", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('kp')
      },
      {
        headerTooltip: 'CK - NAPCK',
        // this.domicileDesc('CK'),
        headerName: "CK", field: "ck", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('ck')
      },
      {
        headerTooltip: 'CC - NAPCC',
        // this.domicileDesc('CC'),
        headerName: "CC", field: "cc", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('cc')
      },
      {
        headerTooltip: 'MZ - MTM Mazda',
        // this.domicileDesc('MZ'),
        headerName: "MZ", field: "mz", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('mz')
      },
      {
        headerTooltip: 'NC - TBMNC',
        // this.domicileDesc('NC'),
        headerName: "NC", field: "nc", floatingFilterComponentParams: { suppressFilterButton: true,filterChangedCallback: (value: any, colId: any) => {
          
          this.filterColumns(value, colId);
        } }, floatingFilter: true,
  minWidth: 48, maxWidth: 48, 
  floatingFilterComponent: PopupComponent, cellRenderer: CellsComponent, hide: this.shouldhide('nc')
      },
      {
        headerName: "NEXT CONNECTION", field: "next_connection", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, //maxWidth: 150, 
        hide: this.shouldhide('next_connection'),
        comparator: this.dateComparator
      },
      {
        headerName: "EXPEDITES", field: "expedites", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 80, //maxWidth: 95, 
        hide: this.shouldhide('expedites')
      },
      {
        headerName: "PULL AHEADS", field: "pull_aheads", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 80, //maxWidth: 110, 
        hide: this.shouldhide('pull_aheads'),
        valueGetter: this.getPullAheadsValue
      },
      {
        headerName: "TAIL LOADS", field: "tail_loads", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 100, //maxWidth: 120, 
        hide: this.shouldhide('tail_loads')
      },
      {
        headerName: "OTHERS", field: "others", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        sortable: true, unSortIcon: true, minWidth: 73, //maxWidth: 90,
         hide: this.shouldhide('others')
      },
      {
        headerName: "COMMENTS", field: "comments", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 230, //maxWidth: 300,
        wrapText: true,
        autoHeight: true,
        cellStyle: { cursor: 'pointer' },
        cellRenderer: CommentRendererComponent,
        hide: this.shouldhide('comments')
      },
      {
        headerName: "ACTION", field: "action", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: false,
        cellRenderer: SearchImgCellRendererComponent, minWidth: 80, //maxWidth: 90, 
        hide: this.shouldhide('action')
      },

    ]
  }

  getPullAheadsValue(params: any){
    if(params.data.pull_aheads == null)  // NOSONAR
    {
      params.data.pull_aheads = 0;
    }
    
    return params.data.pull_aheads;
}

  dateFormatter(res) {
    return res ? moment(res).format('MM/DD/YYYY HH:mm') : null;
  }
  nextDateFormatter(res) {
    return res ? moment(res).format('MM/DD/YYYY 00:00') : null;
  }
  save() {
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.successMessage = null;
    this.errorMessage = null;
    const data=this.preferenceData.map((item)=>{
       return{
        // prefSeqId:this.preference[0].prefSeqId,
        prefSeqId: this.prefSeqId,
        colName:item.colName,
        name:item.name,    
        colIndex:item.colIndex,
        hidden:item.hidden,
        width:item.width
      };
      
      })
    this.buttonService?.saveload(data, this.toyotaGUID)?.subscribe(
      (result) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.successMessage = result;
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants?.APIErrorMessage;
      }
    );
  }


  close() {
    this.errorMessage = null;
    this.successMessage = null;
  }

  reset() {
    this.successMessage = null;
    this.errorMessage = null;
    this.preferenceData = [
      { colName: 'Closed', name: 'last_updated', colIndex: 0, hidden: false, width: 120, },
       { colName: 'ID', name: 'event_id', colIndex: 1, hidden: true, width: 60, }, 
       { colName: 'Type', name: 'event_type', colIndex: 2, hidden: false, width: 60, }, 
       { colName: 'Problem Type', name: 'problem_type', colIndex: 3, hidden: false, width: 100, }, 
       { colName: 'Route', name: 'puroute', colIndex: 4, hidden: false, width: 60, }, 
       { colName: 'U/L', name: 'arrival', colIndex: 5, hidden: false, width: 80, }, 
       { colName: 'Route Group', name: 'route', colIndex: 6, hidden: true, width: 60, }, 
       { colName: 'Run', name: 'run', colIndex: 7, hidden: true, width: 60, }, 
       { colName: 'Region', name: 'region', colIndex: 8, hidden: false, width: 60, }, 
       { colName: 'Status ID', name: 'status_id', colIndex: 9, hidden: true, width: 60, }, 
       { colName: 'Status', name: 'status', colIndex: 10, hidden: true, width: 60, }, 
       { colName: 'Problem Type ID', name: 'problem_type_id', colIndex: 11, hidden: true, width: 60, }, 
       { colName: 'LP ID', name: 'transportation_provider_id', colIndex: 12, hidden: true, width: 60, }, 
       { colName: 'LP', name: 'transportation_provider', colIndex: 13, hidden: true, width: 60, }, 
       { colName: 'Trailer', name: 'eventTrailer', colIndex: 14, hidden: false, width: 60, }, 
       { colName: 'ETA', name: 'eta', colIndex: 15, hidden: true, width: 60, }, 
       { colName: 'Last Updated By', name: 'last_updated_by', colIndex: 16, hidden: true, width: 60, }, 
       { colName: 'AB', name: 'ab', colIndex: 17, hidden: false, width: 20, }, 
       { colName: 'AL', name: 'al', colIndex: 18, hidden: false, width: 20, }, 
       { colName: 'BC', name: 'bc', colIndex: 19, hidden: false, width: 20, }, 
       { colName: 'C', name: 'c', colIndex: 20, hidden: false, width: 20, }, 
       { colName: 'E', name: 'e', colIndex: 21, hidden: false, width: 20, }, 
       { colName: 'G', name: 'g', colIndex: 22, hidden: false, width: 20, }, 
       { colName: 'I', name: 'i', colIndex: 23, hidden: false, width: 20, }, 
       { colName: 'K', name: 'k', colIndex: 24, hidden: false, width: 20, }, 
       { colName: 'MS', name: 'ms', colIndex: 25, hidden: false, width: 20, }, 
       { colName: 'MT', name: 'mt', colIndex: 26, hidden: false, width: 20, }, 
       { colName: 'TX', name: 'tx', colIndex: 27, hidden: false, width: 20, }, 
       { colName: 'U', name: 'u', colIndex: 28, hidden: false, width: 20, }, 
       { colName: 'WV', name: 'wv', colIndex: 29, hidden: false, width: 20, }, 
       { colName: 'Next Connection', name: 'next_connection', colIndex: 30, hidden: true, width: 60, }, 
       { colName: 'Expedites', name: 'expedites', colIndex: 31, hidden: false, width: 80, }, 
       { colName: 'Pull Aheads', name: 'pull_aheads', colIndex: 32, hidden: false, width: 70, }, 
       { colName: 'Tail Loads', name: 'tail_loads', colIndex: 33, hidden: false, width: 70, }, 
       { colName: 'Others', name: 'others', colIndex: 34, hidden: false, width: 70, }, 
       { colName: 'Comments', name: 'comments', colIndex: 35, hidden: false, width: 150, }, 
       { colName: 'Action', name: 'action', colIndex: 36, hidden: false, width: 100, }, ];
    
    const data=this.preferenceData.map((item)=>{
       return{
        //  prefSeqId:this.preference[0].prefSeqId,
        prefSeqId: this.prefSeqId,
       colName:item.colName,
       name:item.name,    
       colIndex:item.colIndex,
       hidden:item.hidden,
       width:item.width
      };   
      })
    this.buttonService?.resetload(data,this.toyotaGUID).subscribe(
      (result) => {
        this.successMessage = result;
      },
      (error) => {
        console.info(error);
        this.errorMessage = this.constants?.APIErrorMessage;
      }
    );
    this.getColDefs();
  }

  openDeletions() {
    this.dialog.open(ViewEventDeletionsComponent, {
      width: '820px'
    });
  }

  openLegends() {
    this.dialog?.open(LegendsComponent, {
      width: '540px',
      height: '290px'
    })
  }

  openColumns() {
    this.dialog.open(ColumnOptionsComponent,
      {
        width: '25%',
        height: '395px',
        data: {
          coldef: this.preferenceData
        }
      }).afterClosed().subscribe(result => {
        this.preferenceData = result.data;
        this.getColDefs();
      });
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) {  // NOSONAR
      return 0; 
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  onModelUpdated(): void {
    this.sizeToFit();
  }

  private updateGridRows(rows: any[]): void {
    if (typeof this.gridApi?.applyTransaction === 'function') {
      const existingRows: any[] = [];
      this.gridApi.forEachNode?.((node: any) => {
        if (node?.data) {
          existingRows.push(node.data);
        }
      });
      if (existingRows.length) {
        this.gridApi.applyTransaction({ remove: existingRows });
      }
      if (rows?.length) {
        this.gridApi.applyTransaction({ add: rows });
      }
      return;
    }

    if (typeof this.gridApi?.setGridOption === 'function') {
      this.gridApi.setGridOption('rowData', rows);
      return;
    }

    if (typeof this.gridApi?.setRowData === 'function') {
      this.gridApi.setRowData(rows);
    }
  }
  
  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.gridApi = params.api;
    this.errorMessage = null;
    this.successMessage = null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      displayName: fgaDetails?.user?.displayName,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.buttonService?.getGridData(userInfo)?.subscribe(
      (response: any) => {
        this.displayRowData = response.map((item: any) => {
          return {
            ...item,
            last_updated: this.dateFormatter(item.last_updated),
            arrival: this.dateFormatter(item.arrival),
            eta: this.dateFormatter(item.eta),
            next_connection: this.nextDateFormatter(item.next_connection),

          };
        });
        this.displayRowDataCopy  = Object.assign([], this.displayRowData);
  this.updateGridRows(this.displayRowData);
        this.rowCount = this.displayRowData.length;
        
        this.gridApi?.redrawRows();
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      _error => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants?.APIErrorMessage;
      });
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){ // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
         
    }
  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

  filterColumns(valueArr, colId) {
    // Keep active popup filters by column id.
    if (valueArr?.length) {
      this.activeColumnFilters[colId] = valueArr;
    } else {
      delete this.activeColumnFilters[colId];
    }

    // Start from original dataset and apply all active column filters.
    let filtered = [...this.displayRowDataCopy];
    Object.keys(this.activeColumnFilters).forEach((activeColId) => {
      const currentValues = this.activeColumnFilters[activeColId] ?? [];
      if (currentValues.length) {
        filtered = filtered.filter((row) =>
          currentValues.some((item) => row?.[activeColId] == item?.value)  // NOSONAR
        );
      }
    });

    // De-duplicate by event id and render filtered rows directly.
    const ids = filtered.map(({ event_id }) => event_id);
    filtered = filtered.filter(({ event_id }, index) => !ids.includes(event_id, index + 1));

    this.updateGridRows(filtered);
    this.rowCount = filtered.length;
    this.onPaginationChanged();
  } 

  filterRowData(colId, valueArr) {
    // filter starts here...
    const temp = [] ;
    if(valueArr.length>0){
      for (const arr in this.filtered) {// NOSONAR
        for (const filter in valueArr) {
          if (this.filtered[arr][colId] == valueArr[filter].value) { // NOSONAR
            temp.push(this.filtered[arr]);
          }
        }
      } 
      this.filtered = Object.assign([], temp);
    }
  }

}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}
